import { TriangleExclamationIcon } from '../../../assets/icons';
import { Flex } from '../../Layout';
import { Text } from '../../Text';

type ErrorMessageProps = {
  testId?: string;
  variant?: 'dark' | 'light';
  children: React.ReactNode;
};

export const ErrorMessage = ({ testId, variant = 'light', children }: ErrorMessageProps) => {
  return (
    <Flex marginTop={10} data-testid={testId}>
      {variant === 'dark' ? (
        <>
          <TriangleExclamationIcon color="white" width={20} marginRight={10} />
          <Text color="white">{children}</Text>
        </>
      ) : (
        <Text testId={testId} color="burgundy">
          {children}
        </Text>
      )}
    </Flex>
  );
};
